(function() {
    /**This module intension is to share data between all the controller related to the search***/
    angular
      .module('meanApp')
      .service('searchData', searchData);
  
      searchData.$inject = ['$rootScope'];
      function searchData ($rootScope) {
        
        this._tagsSelected = [];
        this._textSearch = '';
        this._tags= {
            aperitif : false,
            entry: false,
            maincourse: false,
            dessert: false,
            sweet: false,
            savory: false,
            hot: false,
            cold: false,
            pleasure: false,
            vegan: false,
            vegetarian: false,
            lowcarb: false,
            protein: false,
            lowcalory: false,
            paleo: false,
            season: false,
            local: false,
            nopig: false,
            nogluten: false,
            eco: false,
            fast: false,
            nomicrowave: false,
            nooven: false,
            nohob : false,
            complicated: false
        };
        this._recipesCount = 0;
        //this.odNumberRecipes = null;
         
        this.getTags = function() {
            return this._tags;
        };

        this.getRecipesCount = function() {
            return this._recipesCount;
        };

        this.setRecipeCount = function(count) {
            this._recipesCount= count;
        };

        this.setTagsSelected = function(arrayTags) {
            this._tagsSelected= arrayTags;
        };

        this.getTagsSelected = function () {
            return this._tagsSelected;
        };

        this.setTextSearch = function(textSearch) {
            this._textSearch= textSearch;
        };

        this.getTextSearch= function () {
            return this._textSearch;
        };

        this._recipesCached = [];
        this._tagsCached = '';//a string that represents the last request
        this._totalCountCached = null;
        this._currentPageCached = 0;

        //be careful with what kind of data is cached here
        this.setCache = function(tagsSelected, currentPage, totalCount, recipes) {
            //1- if the tags were different then fill cache
            if(tagsSelected.join('') != this._tagsCached) {
                this._tagsCached = tagsSelected.join('');//cache the tags asked
                this._recipesCached = recipes;
                this._totalCountCached = totalCount;
                this._currentPageCached = currentPage;
            }
            else if((currentPage - this._currentPageCached) === 1){
                //2- if tags are the same AND page is +1 then concat it
                this._recipesCached = this._recipesCached.concat(recipes);
                this._currentPageCached = currentPage;
                this._totalCountCached = totalCount;
            }
            else {
                // 3- tags are the same and page is not +1 then clear cache (must not happen normally)
                //but this is cleaned to be careful
                this._recipesCached = [];
                this._tagsCached = '';//a string that represents the last request
                this._totalCountCached = null;
                this._currentPageCached = 0;
            }
        };

        this.getCache = function(tagsSelected, currentPage) {
            //return the cache if same tags even if not the same page
            var cache = '';
            console.log('same tags cached ?', this._tagsCached == tagsSelected.join(''));
            if(this._tagsCached == tagsSelected.join('')) {
                //if currentPageAsked is smaller or equal to the one cached
                console.log('went here');
                if (this._currentPageCached >= currentPage) {
                    console.log('and also went here');
                    cache = {};
                    cache.recipes = this._recipesCached;
                    cache.totalCount = this._totalCountCached;
                    cache.currentPage = this._currentPageCached;
                }
            }
            //if else that means we can't rely on cache
            return cache;
        };

        return this;
      }
  
  })();